(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('[data-rideshift]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const images = [...root.querySelectorAll('[data-gallery-image]')];
      const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
      let active = 0;
      const show = index => {
        active = (index + images.length) % images.length;
        images.forEach((image, i) => { image.hidden = i !== active; image.classList.toggle('is-active', i === active); });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === active)));
        root.querySelector('[data-gallery-count]').textContent = `${String(active + 1).padStart(2, '0')} / ${String(images.length).padStart(2, '0')}`;
      };
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
      root.querySelector('[data-gallery-prev]').addEventListener('click', () => show(active - 1));
      root.querySelector('[data-gallery-next]').addEventListener('click', () => show(active + 1));
      const gallery = root.querySelector('.rs-gallery-main');
      gallery.addEventListener('keydown', e => { if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); show(active + (e.key === 'ArrowLeft' ? -1 : 1)); } });
      let touchStart;
      gallery.addEventListener('touchstart', e => { touchStart = e.changedTouches[0].clientX; }, {passive:true});
      gallery.addEventListener('touchend', e => { const delta = e.changedTouches[0].clientX - touchStart; if (Math.abs(delta) > 50) show(active + (delta < 0 ? 1 : -1)); }, {passive:true});
      const kits = [...root.querySelectorAll('[data-rs-kit]')];
      kits.forEach(kit => kit.addEventListener('change', () => {
        if (!kit.checked) return;
        root.querySelectorAll('[data-rs-price]').forEach(el => el.textContent = kit.dataset.price);
        root.querySelectorAll('[data-rs-compare]').forEach(el => el.textContent = kit.dataset.comparePrice);
        root.querySelectorAll('[data-rs-discount]').forEach(el => el.textContent = `${kit.dataset.discount}% OFF`);
        root.querySelectorAll('[data-rs-atc]').forEach(el => { el.disabled = kit.dataset.available !== 'true'; el.textContent = el.disabled ? 'Sold out' : 'ADD TO CART'; });
        if (location.pathname.includes('/products/')) {
          const url = new URL(location.href); url.searchParams.set('variant', kit.value); history.replaceState({}, '', url);
        }
      }));
      const sticky = root.querySelector('[data-sticky-buy]');
      const form = root.querySelector('.rs-purchase-form');
      if (sticky && form) {
        const observer = new IntersectionObserver(entries => { const entry = entries[0]; sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; }, {threshold:0});
        observer.observe(form);
        root._rsObserver = observer;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', e => initialize(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-rideshift]').forEach(root => root._rsObserver?.disconnect()));
})();

// Keep the purchase flow on the current page until the customer chooses checkout.
(() => {
  if (window.rideShiftCartReady) return;
  window.rideShiftCartReady = true;

  const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);
  const cart = document.createElement('div');
  cart.className = 'rs-cart';
  cart.hidden = true;
  cart.innerHTML = '<div class="rs-cart-shade" data-rs-cart-close></div><aside class="rs-cart-panel" role="dialog" aria-modal="true" aria-label="Your bag" tabindex="-1"><div class="rs-cart-head"><h2>Your bag</h2><button type="button" data-rs-cart-close aria-label="Close bag">×</button></div><div class="rs-cart-items" aria-live="polite"></div><div class="rs-cart-foot"><p><span>Subtotal</span><strong class="rs-cart-total"></strong></p><small>Free standard US shipping</small><a class="rs-cart-checkout" href="/checkout">Continue to checkout</a><button type="button" class="rs-cart-continue" data-rs-cart-close>Continue shopping</button></div></aside>';
  document.body.append(cart);
  let previousFocus;
  const open = () => {
    previousFocus = document.activeElement;
    cart.hidden = false;
    document.body.classList.add('rs-cart-open');
    cart.querySelector('.rs-cart-panel').focus();
  };
  const close = () => {
    cart.hidden = true;
    document.body.classList.remove('rs-cart-open');
    previousFocus?.focus?.();
  };
  cart.querySelectorAll('[data-rs-cart-close]').forEach(button => button.addEventListener('click', close));
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && !cart.hidden) close(); });

  async function refreshCart() {
    const response = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Could not load your bag.');
    const state = await response.json();
    document.querySelectorAll('.rs-bag span').forEach(label => { label.textContent = `Bag (${state.item_count})`; });
    const items = cart.querySelector('.rs-cart-items');
    items.innerHTML = state.items.length ? state.items.map(item => `<div class="rs-cart-item">${item.image ? `<img src="${escape(item.image)}" alt="" width="84" height="84">` : ''}<div><strong>${escape(item.product_title)}</strong><small>${escape(item.variant_title === 'Default Title' ? '' : item.variant_title)}</small><span>Qty ${item.quantity} · ${money(item.final_line_price)}</span><button type="button" data-rs-remove="${escape(item.key)}">Remove</button></div></div>`).join('') : '<p class="rs-cart-empty">Your bag is empty.</p>';
    cart.querySelector('.rs-cart-total').textContent = money(state.total_price);
    cart.querySelector('.rs-cart-foot').hidden = !state.items.length;
    return state;
  }

  document.addEventListener('click', async event => {
    const bag = event.target.closest('.rs-bag');
    if (bag) {
      event.preventDefault();
      try { await refreshCart(); open(); } catch (error) { location.href = '/cart'; }
    }
  });
  cart.addEventListener('click', async event => {
    const remove = event.target.closest('[data-rs-remove]');
    if (!remove) return;
    remove.disabled = true;
    try {
      const response = await fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: remove.dataset.rsRemove, quantity: 0 }) });
      if (!response.ok) throw new Error();
      await refreshCart();
    } catch (_) { remove.disabled = false; }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.rs-purchase-form');
    if (!form) return;
    event.preventDefault();
    const button = event.submitter || form.querySelector('[data-rs-atc]');
    button.disabled = true;
    const previousText = button.textContent;
    button.textContent = 'ADDING…';
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) { const detail = await response.json(); throw new Error(detail.description || 'Could not add this kit.'); }
      await refreshCart();
      open();
    } catch (error) { alert(error.message); }
    finally { button.disabled = false; button.textContent = previousText; }
  });
})();
